import { Component, OnInit, OnDestroy } from '@angular/core';
import { Company, Tool, Icons, User, UserType } from 'toolbandi-ui-lib';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService, CrudService, MessageService, Breadcrumb } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ToolEditComponent } from '../tool-edit/tool-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-tool-view',
	templateUrl: './tool-view.component.html',
	styleUrls: ['./tool-view.component.scss']
})
export class ToolViewComponent implements OnInit, OnDestroy {

	company: Company;
	loading: boolean = false;
	tool: Tool;
	breadcrumb: Breadcrumb;


	error: boolean;

	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private toolService: CrudService<Tool>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private companyService: CrudService<Company>
	) {

	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
		});
	}

	load(id: number): void {
		this.loading = true;
		this.toolService.getEntity(Tool, 'tool', id).subscribe(tool => {
			this.tool = tool;
			if (this.tool) {
				this.error = false;
				this.companyService.getEntity(Company, 'company', this.tool.companyid).subscribe(company => {
					this.company = company;
					this.loading = false;
					this.setBreadcrumb();
				});
			} else {
				this.error = true;
				this.loading = false;
			}

		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.tool'));
			this.tool = undefined;
			this.loading = false;
			this.error = true;
		});

	}


	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.companies', url: '/company' },
			{ title: this.company.name, url: '/company/view/' + this.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
		];
		this.breadcrumb.title = { title: 'labels.view-tool', param: this.tool.name, icon: Icons.TOOL, icontooltip: 'labels.tool' };
	}

	edit() {
		const modal = this.modalService.open(ToolEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.comanyid = this.tool.companyid;
		modal.componentInstance.load(this.tool.id);

		modal.result.then((newItem: Tool) => {
			this.load(this.tool.id);
		}).catch(() => {});
	}


}
